"use client";

import { useEffect, useState } from "react";
import { Trophy, Users, Zap, Heart } from "lucide-react";
import { useTranslations } from "next-intl";
import { api } from "@/shared/lib/api";

type AboutStats = {
  tournamentsCount: number;
  usersCount: number;
  onlineUsersCount: number;
};

const DEVELOPERS_COUNT = 4;

export function AboutStatsCards() {
  const t = useTranslations("Marketing.About.stats");
  const [stats, setStats] = useState<AboutStats | null>(null);

  useEffect(() => {
    api
      .get<AboutStats>("/marketing/about-stats")
      .then((res) => setStats(res.data))
      .catch(() => setStats({ tournamentsCount: 0, usersCount: 0, onlineUsersCount: 0 }));
  }, []);

  const display = stats ?? {
    tournamentsCount: 0,
    usersCount: 0,
    onlineUsersCount: 0,
  };

  const items = [
    { value: display.tournamentsCount, label: t("tournaments"), icon: Trophy },
    { value: display.usersCount, label: t("participants"), icon: Users },
    { value: display.onlineUsersCount, label: t("support"), icon: Zap },
    { value: DEVELOPERS_COUNT, label: t("security"), icon: Heart },
  ];

  return (
    <div className="rounded-2xl bg-black/6 dark:bg-white/4 px-6 py-5">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
        {items.map(({ value, label, icon: Icon }) => (
          <div key={label} className="text-center flex flex-col items-center justify-center gap-1">
            <Icon className="h-8 w-8 text-primary" />
            <div className="text-2xl font-bold">{value}</div>
            <div className="text-sm text-muted-foreground">{label}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
